import { render, staticRenderFns } from "./StartApp.vue?vue&type=template&id=63683898&"
import script from "./StartApp.vue?vue&type=script&lang=js&"
export * from "./StartApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports